import {
  OpsHttpInspectorEntry,
  OpsHttpInspectorQueryParam,
} from "../models/ops-http-inspector-entry.model";

export type OpsHttpInspectorTone = "pending" | "ok" | "warn" | "error";

export function formatOpsHttpDuration(durationMs: number | null): string {
  if (durationMs === null) {
    return "…";
  }
  if (durationMs < 1000) {
    return `${durationMs} ms`;
  }
  return `${(durationMs / 1000).toFixed(2)} s`;
}

export function formatOpsHttpTimestamp(epochMs: number): string {
  return new Date(epochMs).toLocaleTimeString([], { hour12: false });
}

export function getOpsHttpStatusTone(entry: OpsHttpInspectorEntry): OpsHttpInspectorTone {
  if (entry.status === "pending") {
    return "pending";
  }
  if (entry.status === "error" || (entry.statusCode ?? 0) >= 500) {
    return "error";
  }
  if ((entry.statusCode ?? 0) >= 400) {
    return "warn";
  }
  return "ok";
}

export function truncateOpsHttpUrl(url: string, maxLength = 72): string {
  if (url.length <= maxLength) {
    return url;
  }
  return `${url.slice(0, maxLength - 1)}…`;
}

/** Splits a full request URL into its base (no query string) and parsed query params. */
export function parseOpsHttpUrl(url: string): {
  baseUrl: string;
  queryParams: OpsHttpInspectorQueryParam[];
} {
  const [baseUrl, queryString] = url.split("?", 2);
  if (!queryString) {
    return { baseUrl, queryParams: [] };
  }
  const queryParams = Array.from(new URLSearchParams(queryString).entries()).map(
    ([key, value]) => ({ key, value }),
  );
  return { baseUrl, queryParams };
}
